import {getUrlAction, PP_CLIENT_WRAPPER_SETTINGS_PARAMETERS_SCHEMA, PPClientSideMessages, PPSettings, URL_ACTIONS} from '@gongxigames/framework/integrations/pariplay';
import {RubyPlayGameClientWrapper} from '@gongxigames/framework/integrations/rubyplay/RubyPlayGameClientWrapper';
import {CoreDI, Device, GameClientWrapperProperties, inject} from '@gongxigames/framework/slot';
import {PariplayFusionPostMessagesHandler} from '@gongxigames/framework/integrations/fusion/PariplayFusionPostMessagesHandler';
import {ServerResponseData} from '@gongxigames/framework/integrations/rubyplay/types';

export class PariplayFusionGameClientWrapper extends RubyPlayGameClientWrapper {
    public static readonly NAME: string = 'fusion';
    @inject(CoreDI.Device)
    protected _device!: Device;

    protected _clientSideMessagesHandler!: PariplayFusionPostMessagesHandler;

    protected onInitResponse(data: ServerResponseData): void {
        super.onInitResponse(data);

        this._eventManager.emit(PPClientSideMessages.GAME_LOADED);
    }

    public initWrapper(properties: GameClientWrapperProperties): void {
        super.initWrapper(properties);

        this._settings.addParametersSchema(PP_CLIENT_WRAPPER_SETTINGS_PARAMETERS_SCHEMA);

        const settings = this.getSettings<PPSettings>();

        this._clientSideMessagesHandler = new PariplayFusionPostMessagesHandler(
            this._eventManager,
            this.emitter,
            this._browser,
            settings.get('gameCode'),
            settings.get('lang')
        );
    }

    protected redirectToCashier(): void {
        const cashierUrl = this.getSettings<PPSettings>().get('cashierUrl');

        this._eventManager.emit(PPClientSideMessages.CASHIER_CLICKED);

        switch (getUrlAction(cashierUrl)) {
            case URL_ACTIONS.BACK:
                this.goToBack();
                break;
            case URL_ACTIONS.API:
                break;
            default:
                if (cashierUrl) {
                    this._eventManager.emit(PPClientSideMessages.CASHIER_CLICKED);
                    this.redirect(cashierUrl);
                }
                break;
        }
    }

    protected redirectToHomeUrl(): void {
        const homeUrl = this.getSettings<PPSettings>().get('homeUrl');

        switch (getUrlAction(homeUrl)) {
            case URL_ACTIONS.BACK:
                this.goToBack();
                break;
            case URL_ACTIONS.API:
                this._eventManager.emit(PPClientSideMessages.QUIT_GAME);
                break;
            default:
                if (homeUrl) {
                    this._eventManager.emit(PPClientSideMessages.QUIT_GAME);
                    this.redirect(homeUrl);
                }
                break;
        }
    }

    protected goToBack(): void {
        this._eventManager.emit(PPClientSideMessages.QUIT_GAME);

        window.history.go(-1);
    }

    protected redirect(url: string): void {
        if (this.getSettings<PPSettings>().get('dontLoadUrlFromParent')) {
            location.href = url;
        } else if (window.top) {
            window.top.location.href = url;
        } else {
            window.location.href = url;
        }
    }
}
